import type { LaneMinimumSchedule } from "../../hooks/react-query/backOffice/useLaneMinimumSchedules";

export const mockLaneMinimumSchedules: LaneMinimumSchedule[] = [
  {
    id: 1,
    name: "Standard Lane Minimums",
    description: "Blind Shipment Fee",
    status: "Active",
    laneMinimumCount: 10,
    createdBy: "Carlos Mendez",
    createdOn: "11/5/2025",
    modifiedBy: "Carlos Mendez",
    modifiedOn: "11/5/2025",
    isGlobal: false,
  },
  {
    id: 2,
    name: "Regular Lane Minimums",
    description: "Standard shipping lanes",
    status: "Active",
    laneMinimumCount: 12,
    createdBy: "Sarah Johnson",
    createdOn: "10/15/2025",
    modifiedBy: "Sarah Johnson",
    modifiedOn: "10/20/2025",
    isGlobal: false,
  },
  {
    id: 3,
    name: "Regular Lane Minimums",
    description: "Extended coverage lanes",
    status: "Active",
    laneMinimumCount: 24,
    createdBy: "Mike Chen",
    createdOn: "09/01/2025",
    modifiedBy: "Mike Chen",
    modifiedOn: "09/15/2025",
    isGlobal: false,
  },
];

export const mockLaneMinimumScheduleDetail = {
  id: 1,
  name: "Standard Lane Minimums",
  description: "Blind Shipment Fee",
  status: "Active",
  laneMinimums: [
    {
      id: 1,
      sequence: 1,
      originType: "State",
      originLocation: "CA",
      originLocationName: null,
      destinationType: "State",
      destinationLocation: "CO",
      destinationLocationName: null,
      minimumCharge: "150.00",
      direction: "One Way",
    },
    {
      id: 2,
      sequence: 2,
      originType: "State",
      originLocation: "AZ",
      originLocationName: null,
      destinationType: "State",
      destinationLocation: "CO",
      destinationLocationName: null,
      minimumCharge: "200.50",
      direction: "Both Ways",
    },
    {
      id: 3,
      sequence: 3,
      originType: "Zone",
      originLocation: "103",
      originLocationName: null,
      destinationType: "Zone",
      destinationLocation: "2",
      destinationLocationName: null,
      minimumCharge: "300.75",
      direction: "One Way",
    },
  ],
};
